// internal
import App from '@/page/app/app.vue';

import { send } from './api/send';
import router from './router/index';


// general
import { createPinia } from 'pinia';
import { createApp } from 'vue';

// stores
import { Audio } from './store/audio';
import { Demo } from './store/demo';
import { Profile } from './store/profile';

// ui
import Footer from '../page/app/footer.vue';
import Head from '../page/app/head.vue';
import { install } from '../ui/index';

// login
import VueAppleLogin from 'vue-apple-login';
import vue3GoogleLogin from 'vue3-google-login';

// plugins
import 'tippy.js/dist/tippy.css'; // optional for styling
import VueTippy from 'vue-tippy';

// audio
// https://github.com/goldfire/howler.js#documentation
// https://ffmpegwasm.netlify.app/docs/overview/
// https://audiomass.co
// https://wavesurfer.xyz/examples/?regions.js

// directives
import OutsideClick from "@/ts/directives/outside";
import UploadDirective from "@/ts/directives/upload";

// api
import tools from '@/ts/tools/index';

// app
const app = createApp(App)

// pinia
app.use(createPinia())

// ui components
install(app)

app.component('Head',Head)
app.component('Footer',Footer)

// stores
app.config.globalProperties.db = Profile()
app.config.globalProperties.demo = Demo()
app.config.globalProperties.audio = Audio()
app.config.globalProperties.audio.initialize()

// is dev
app.config.globalProperties.dev = process.env.NODE_ENV == 'development'

// router
app.use(router);
router.isReady().then(() => {app.mount('#app')});

// charts
// app.use(VueApexCharts);


//google
app.use(vue3GoogleLogin, {clientId: '956848353375-0et77n08fs1lpen07e9tis867d2eka35.apps.googleusercontent.com'})

// apple
app.use(VueAppleLogin, {clientId: 'app.toodemo.com',scope: 'name email',redirectURI: 'https://api.toodemo.com/apple/oauth', state: 'signup',usePopup: true,})


// Инициализируем хранилище после установки




// tippy
app.use(
    VueTippy, {    
      directive: 'tippy', // => v-tippy
      component: 'tippy', // => <tippy/>
      componentSingleton: 'tippy-singleton', // => <tippy-singleton/>,
      defaultProps: {
        // placement: 'auto-end',
        allowHTML: true,
        interactive: true,
        delay: [500, null],
        duration: [300, 100],
        theme: 'xxx',
      }, // => Global default options * see all props
    }
  )
  

// upload
app.directive('upload', UploadDirective)
// app.directive('color', ColorDirective)
// app.directive('drop', DropDirective)
// app.directive('dragover', DragOverDirective)
app.directive('out', OutsideClick)
// app.directive('help', Tooltip)
// app.directive('tooltip', Tooltip);

// router helper
app.config.globalProperties.go = function(name: string) {router.push({name:name})}
app.config.globalProperties.golink = function(link: string) {router.push(link)}
app.config.globalProperties.is = function(name: string) {return router.currentRoute.value.name == name}
app.config.globalProperties.openlink = function(link: string) {window.open(link, '_blank');}
app.config.globalProperties.copyText = async function(text: string) { await navigator.clipboard.writeText(text)}
 
// api
// app.config.globalProperties.api = api

// tools

app.config.globalProperties.tools = tools
app.config.globalProperties.send = send

// lang
// app.config.globalProperties.en = i18n.global.locale == 'en'
// app.config.globalProperties.ru = i18n.global.locale == 'ru'
// app.config.globalProperties.lang = i18n.global.locale


// clipboard







